module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.8feb27f3.woff";